import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { CapacityRovoConfigProviderEntrypointProps } from './CapacityRovoConfigProvider.entrypoint.types.tsx';

type CapacityRovoConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	CapacityRovoConfigProviderEntrypointProps,
	{} | null
>;

export const capacityRovoConfigProviderEntrypoint: EntryPoint<
	CapacityRovoConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<CapacityRovoConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-capacity-provider" */ './CapacityRovoConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
